<template>
    <div class="assembly_box p-works-contribution-page">
        <common-top :commonTopData="commonTopData" ></common-top>
        <el-row class="p-operation">
            <el-col :span="12">
                <el-tabs class="p-tabs" v-model="checkStatus" @tab-click="tabHandleClick">
                    <el-tab-pane label="我的待审" name="0"></el-tab-pane>
                    <el-tab-pane label="我通过的" name="1"></el-tab-pane>
                    <el-tab-pane label="未通过的" name="-1"></el-tab-pane>
                    <el-tab-pane label="全部记录" name="all"></el-tab-pane>
                    <el-tab-pane label="内容干预" name="4"></el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="12" class="p-right-operation-btn">
                <div>
                    <!-- <el-button v-if="checkStatus==4" type="primary" @click="add_intervene">新增干预</el-button> -->
                    <el-tabs v-if="checkStatus=='4'" v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane :label="val.label" :name="val.value" v-for="(val,index) in category_arr" :key="index">
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div>
                <el-button class="p-fitler-btn" type="text" size="mini" @click="batch_fun"
                v-if="checkStatus=='0'||checkStatus=='1' || checkStatus=='4'">
                    <img src="~@/assets/img/icon_sx.svg">{{checkStatus=='0'?'批量审核':'批量操作'}}
                </el-button>
                <el-button class="p-fitler-btn" type="text" size="mini" @click="drawer = true">
                    <img src="~@/assets/img/icon_sx.svg">筛选
                </el-button>
                </div>
            </el-col>
        </el-row> 
        <div class="p-table-wrap" v-show="!is_batch.pending_batch && !is_batch.through_batch && !is_batch.intervene_batch">
            <!-- <div v-if="checkStatus!=='4'"> -->
                <CommonsTable v-if="checkStatus!=='4'" :checkStatus="checkStatus" :tableTitle="tableTitle" :tableData="tableData.data" :btnList="btnList"/>
            <!-- </div> -->
             <!-- <div v-else> -->
                <CommonsTable v-else :checkStatus="checkStatus" :activeName="activeName" :tableTitle="tableTitle" :tableData="tableData.data" :btnList="ID_btnList"/>
            <!-- </div> -->
        </div>
        <!-- 分页 -->
        <CommPagination v-show="!is_batch.pending_batch && !is_batch.through_batch && !is_batch.intervene_batch" :data_obj="tableData" :page="page" :limit="limit" 
            @set_page="set_page" @set_limit="set_limit"/>

        <!-- card -->
        <div class="p-card-wrap" v-show="is_batch.pending_batch || is_batch.through_batch || is_batch.intervene_batch">
            <BatchWallpaper :activeName="activeName" :checkStatus="checkStatus" :tableData="tableData.data" :check_arr="check_arr" @set_tableData="set_tableData" @get_check_arr="get_check_arr"/>
             <!-- 分页 -->
            <CommPagination v-show="is_batch.pending_batch || is_batch.through_batch || is_batch.intervene_batch" :data_obj="tableData" :page="page" :limit="limit" 
            @set_page="set_page" @set_limit="set_limit"/>
            <div class="p-operation-wrap">
                <div class="p-count">
                    <span>已选择{{ check_arr.length }}个</span>
                    <el-checkbox v-model="isAllCheck" @input="allCheckChange">全选</el-checkbox>
                </div>
                <div class="p-btns" v-if="is_batch.pending_batch">
                    <el-button @click="close_batch_fun">取消批量审核</el-button>
                    <el-button type="primary" @click="batchExamineClick('1')">审核通过</el-button>
                    <el-button type="danger" @click="batchExamineClick('-1')">审核不通过</el-button>
                </div>
                <div class="p-btns" v-if="is_batch.through_batch">
                    <el-button @click="close_batch_fun">取消批量审核</el-button>
                    <el-button type="success" @click="edit_batchExamineClick('lock_status','0')">免费</el-button>
                    <el-button type="danger" @click="edit_batchExamineClick('lock_status','2')">限免</el-button>
                    <el-button type="primary" @click="edit_batchExamineClick('lock_status','1')">会员</el-button>
                </div>
                <div class="p-btns" v-if="is_batch.intervene_batch">
                    <el-button @click="close_batch_fun">取消批量审核</el-button>
                    <el-button type="primary" @click="edit_batchExamineClick('is_top','1')">显示</el-button>
                    <el-button type="danger" @click="edit_batchExamineClick('is_top','0')">不显示</el-button>
                </div>
            </div>
        </div>
        <!-- 删除 -->
        <el-dialog
        title="提示"
        :visible.sync="del_dialogVisible"
        width="30%"
        :before-close="handleClose_del">
        <span>确认删除这条数据吗？</span>
        <span slot="footer" class="dialog-footer">
            <el-button @click="del_dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="del">确 定</el-button>
        </span>
        </el-dialog>
        <!-- 批量审核弹出框 -->
        <el-dialog
        title="请确认以下将审核通过的素材信息"
        :visible.sync="dialogVisible"
        width="70%"
        :before-close="handleClose">
        <div class="dialog_container" v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-row :gutter="30">
                <el-col :xl="8"
                :lg="12"
                :md="16"
                :sm="24" v-for="(val,index) in check_arr" :key="index">
                    <div class="left_box">
                        <img :src="`${val.prev_url}?x-oss-process=image/resize,w_100`" alt="">
                    </div>
                    <div class="right_box">
                        <p class="dialog_p">
                            <span class="dialog_name">素材名称</span>
                            <!-- <span class="tips">{{val.name}}</span> -->
                            <el-input class="gan_input"
                            placeholder="请输入内容"
                            v-model="val.name"
                            :disabled="true">
                            </el-input>
                        </p>
                        <p class="dialog_p">
                            <span class="dialog_name">素材分类</span>
                            <!-- <span class="tips">{{val.category}}</span> -->
                            <el-input class="gan_input"
                            placeholder="请输入内容"
                            v-model="val.category"
                            :disabled="true">
                            </el-input>
                        </p>
                        <p class="dialog_p">
                            <span class="dialog_name">素材来源</span>
                            <!-- <span class="tips">{{val.source||'--'}}</span> -->
                            <el-input class="gan_input"
                            :placeholder="val.source||'--'"
                            v-model="val.source"
                            :disabled="true">
                            </el-input>
                        </p>
                        <p class="dialog_p" v-if="checkStatus=='4'">
                            <span>权 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 重</span>
                            <!-- <span class="tips">{{activeName=='1'?val.top_sort:val.sort}}</span> -->
                            <el-input class="gan_input" v-if="activeName=='1'" type="text" v-model="val.top_sort"></el-input>
                            <el-input class="gan_input" v-else type="text" v-model="val.sort"></el-input>
                        </p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关闭</el-button>
            <el-button v-if="is_batch.pending_batch" :loading="loading" :type="set_stauts=='1'?'primary':'danger'" @click="check_examine">{{set_stauts=='1'?'确认审核通过':'确认审核不通过'}}</el-button>
            <el-button v-if="is_batch.through_batch" :loading="loading" :type="set_stauts=='0'?'success':(set_stauts=='1'?'primary':'danger')" @click="set_stauts=='2'?open_check_examine():check_examine()">{{set_stauts=='0'?'修改成【免费】':(set_stauts=='1'?'修改成【会员】':'修改成【限免】')}}</el-button>
            <el-button v-if="is_batch.intervene_batch" :loading="loading" :type="set_stauts=='1'?'primary':'danger'" @click="check_examine">{{set_stauts=='1'?'显示':'不显示'}}</el-button>
        </span>
        </el-dialog>
        <!-- 筛选 -->
        <Rawer ref="rawer" @reset="reset" :drawer="drawer" :direction="direction" :rawer_list="checkStatus!='all'?rawer_list:rawer_list2" @screen="screen" @handleClose_drawer="handleClose_drawer"></Rawer>
    
        <el-dialog
        title="提示"
        :visible.sync="edit_dialogVisible"
        width="50%"
        :close-on-click-modal="false"
        :before-close="edit_handleClose">
        <div class="edit_dialogVisible_box">
            <div>
            确定要将当前{{edit_data.lable}}里面的内容修改成：<span class="tips_text_box"> {{edit_data.newValue}} </span> &ensp;  吗？
            </div>
            <div class="picker_box" v-if="edit_data.is_lock">
                <span>请选择限免到期时间：</span>
                <el-date-picker
                :picker-options="setDateRange"
                @change="change_picker"
                v-model="lock_time_val"
                type="datetime"
                placeholder="选择日期时间">
                </el-date-picker>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="edit_handleClose">取 消</el-button>
            <el-button type="primary" @click="edit_confirm">确 定</el-button>
        </span>
        </el-dialog>

        <el-dialog
        title="提示"
        :visible.sync="batch_time_dialogVisible"
        width="30%"
        :append-to-body="true"
        :before-close="batch_handleClose">
        <div class="batch_dialogVisible_box">
            <div>请选择限免到期时间：</div>
            <el-date-picker
            :picker-options="setDateRange"
            @change="change_batch_picker"
            v-model="batch_lock_time_val"
            type="datetime"
            placeholder="选择日期时间">
            </el-date-picker>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="batch_time_dialogVisible = false">取 消</el-button>
            <el-button :loading="loading" type="primary" @click="check_examine_2">确 定</el-button>
        </span>
        </el-dialog>

    
    </div> 
</template>

<script>
import {formatDateTime} from '@/common/utils/util'
import Rawer from '@/components/drawer/drawer'
import CommPagination from '@/components/comm_pagination/comm_pagination.vue'
import BatchWallpaper from '@/components/batch_wallpaper/batch_wallpaper.vue'
import commonTop from '@/components/commonTop1.vue'
import CommonsTable from '@/components/commons_table/commons_table.vue'
import { hasAccess } from '@/common/utils'
export default {
    components: {
        commonTop,
        CommonsTable,
        BatchWallpaper,
        CommPagination,
        Rawer
    },
    data(){
        return{
            setDateRange: {
                disabledDate: time => {
                    // 禁用今天之后的日期【当前天可选】
                    return time.getTime() < Date.now() - 86400000 - 5;
                }
            },
            batch_lock_time_val:'',
            batch_time_dialogVisible:false,
            lock_time_val:'',
            edit_data:{
                lable:'',
                newValue:'', //新值
            },
            fun_callback_data:{},
            commonTopData: {
                "pageName": "photographyContribution", 
                "commonleftbtn": [],
                "commonbottombtn":[],
                "option":[],
                'tabnums':0,
                'mintabnums': 0,
            },
            checkStatus: '0',
            hasAccess,
            tableTitle:[
                {prop:'id',label:'上线ID'},
                {prop:'prev_url',label:'预览图',is_img:true},
                {prop:'name',label:'素材名称',is_input:true,
                    fun:async (da,val)=>{
                        this.fun_callback_data={
                            id:val.id,
                            name:da
                        }
                        this.edit_data = {
                            lable:'素材名称',
                            newValue:da
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {prop:'source',label:'素材来源'},
                {
                    prop:'category',label:'素材分类',is_select:true,props:[],
                    //判断这个字段显不显示的函数
                    is_show_fun(val){
                        return true 
                    },
                    set_prop:(val)=>{
                        return val
                    },
                    fun:async (da,val)=>{

                        this.fun_callback_data={
                            id:val.id,
                            category:da
                        }
                        this.edit_data = {
                            lable:'素材分类',
                            newValue:da
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {prop:'tags',label:'壁纸标签',is_tags:true,is_input:true,
                    fun:async (da,val)=>{
                        let arr = da.split(/[,，]/)
                        this.fun_callback_data={
                            id:val.id,
                            tags:JSON.stringify(arr)
                        }
                        this.edit_data = {
                            lable:'壁纸标签',
                            newValue:da.split(/[,，]/).toString()
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {prop:'',label:'会员状态',is_props:true,is_time:true,props:[
                    {   is_select:true,
                        props_val:[
                            {label:'免费',value:'0'},
                            {label:'会员',value:'1'},
                            {label:'限免',value:'2'},
                        ],
                        prop_name:'lock_status',
                        text_color_name:'lock_status',
                        text_color:(val)=>{
                            switch(val) {
                                case '0':
                                    return '#27AE60'
                                case '1':
                                    return '#33B3FF'
                                case '2':
                                    return '#FF0000'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        },
                        turn_fun:(val)=>{
                            switch(val) {
                                case '0':
                                    return '免费'
                                case '1':
                                    return '会员'
                                case '2':
                                    return '限免'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        },
                        fun:async (da,val)=>{
                            this.fun_callback_data={
                                id:val.id,
                                lock_status:da,
                                lock_time:val.lock_time,
                                is_top:val.is_top
                            }
                            this.edit_data = {
                                lable:'会员状态',
                                newValue:da=='0'?'免费':(da=='1'?'会员':'限免'),
                                is_lock:da=='2'?true:false
                            }
                            this.edit_dialogVisible = true
                        }
                    },
                    // {
                    //     prop_name:'lock_time',
                    //     //判断这个字段显不显示的函数
                    //     is_show_fun(val){
                    //         // console.log(val,'会员状态')
                    //         if(val == '2'){
                    //             return true
                    //         }
                    //         return false 
                    //     },
                        
                    // }
                ]},
                {
                    prop:'lock_time',label:'限免到期时间',is_picker:true,
                    //判断这个字段显不显示的函数
                    is_show_fun(val){
                        // console.log(val,'会员状态')
                        if(val == '2'){
                            return true
                        }
                        return false 
                    },
                    fun:async(da,val)=>{
                        console.log(da,val,'ss')
                        let val_obj = {
                            id:val.id,
                            lock_time:this.dateFormat("YYYY-mm-dd HH:MM", da)
                        }
                        let params = {
                            access_token: localStorage.getItem("access_token"),
                            ...val_obj,
                            operation:true
                        }
        
                        let res = await this.api.wallpaper_edit(params);
                        if(res){
                            if(this.checkStatus == '4'){
                                if(this.activeName=='1'){
                                    var paramss = {
                                        page:this.page,
                                        limit:this.limit,
                                        status:'1',
                                        is_top:this.activeName,
                                        ...this.screen_params,
                                    }
                                }else{
                                    var paramss = {
                                        page:this.page,
                                        limit:this.limit,
                                        status:1,
                                        category:this.activeName,
                                        ...this.screen_params,
                                    }
                                }

                            }else{
                                var paramss = {
                                    ...this.screen_params
                                }
                            }
                            this.get_wallpaper_list(paramss)
                            
                        }else{
                            this.$message({
                                type:'error',
                                message:'操作失败',
                                offset:65,
                            })
                        }
                    }
                },
                {prop:'',label:'当前状态',is_props:true,props:[
                    {
                        text_color_name:'status',
                        prop_name:'status',
                        turn_fun:(val)=>{
                            switch(val) {
                                case '0':
                                    return '待审核'
                                case '1':
                                    return '审核通过'
                                case '-1':
                                    return '审核未通过'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        },
                        text_color:(val)=>{
                            switch(val) {
                                case '0':
                                    return '#33B3FF'
                                case '1':
                                    return '#5CBB44'
                                case '-1':
                                    return '#EEC211'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        }
                    }
                ]},
                {prop:'',label:'审核人/时间',is_props:true,props:[
                    {
                        prop_name:'check_admin_name'
                    },
                    {
                        prop_name:'check_time'
                    }
                ]},
                {
                    prop:'is_top',label:'是否首页展示',is_select:true,props:[
                        {label:'显示',value:'1'},
                        {label:'不显示',value:'0'}
                    ],
                    set_prop:(val)=>{
                        switch(val) {
                            case '1':
                                return '显示'
                            case '0':
                                return '不显示'
                            default:
                                // 默认代码块
                                return val
                        } 
                    },
                    //判断这个字段显不显示的函数
                    is_show_fun(val){
                        if(val == '1' || val == 'all' || val == '4'){
                            return true
                        }
                        return false 
                    },
                    fun: async (select_val,val)=>{

                        this.fun_callback_data={
                            id:val.id,
                            is_top:select_val
                        }
                        this.edit_data = {
                            lable:'是否首页展示',
                            newValue:select_val=='1'?'显示':'不显示'
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {prop:'',label:'权重',is_weight_input:true,
                    fun:async (val)=>{
                        console.log(val)

                        if(this.activeName=='1'){
                            this.fun_callback_data={
                                id:val.id,
                                is_top:'1',
                                top_sort:val.top_sort
                            }
                        }else{
                            this.fun_callback_data={
                                id:val.id,
                                category:this.activeName,
                                sort:val.sort
                            }
                        }

                        this.edit_data = {
                            lable:'权重',
                            newValue:this.activeName=='1'?val.top_sort:val.sort
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {prop:'shelf_status',label:'上下架状态',is_props:true,props:[
                    {
                        //判断这个字段显不显示的函数
                        is_show_fun(val){
                            if(val=='1'){
                                return true
                            }
                            return false
                        },
                        prop_name:'shelf_status',
                        turn_fun:(val)=>{
                            switch(val) {
                                case '0':
                                    return '下架'
                                case '1':
                                    return '上架'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        },
                        text_color_name:'shelf_status',
                        text_color:(val)=>{
                            switch(val) {
                                case '0':
                                    return 'red'
                                case '1':
                                    return '#5CBB44'
                                default:
                                    // 默认代码块
                                    return val
                            } 
                        }
                    }
                ]},
            ],
            ID_tableTitle:[
                {prop:'accrual_id',label:'上线ID'},
                {prop:'accrual_name',label:'展示位置'},
                {prop:'img',label:'预览图',is_img:true},
                {prop:'estimated_income',label:'用户ID'},
                {prop:'recognized',label:'作品评级'},
                {prop:'aa',label:'壁纸分类'},
                {prop:'bb',label:'壁纸标签'},
                {prop:'cc',label:'会员状态',is_props:true,props:['cc','tt']},
                {prop:'dd',label:'当前状态'},
                {prop:'ee',label:'审核人/时间',is_props:true,props:['nn','ee']},
            ],
            tableData: {},  
            btnList:[
                {
                    btn:'详情',
                    btn_type:'text',
                    fun:(val)=>{
                        console.log(val)
                    }
                },
                {
                    btn:'编辑',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit)=>{
                        // console.log(val,is_edit,'is_edit')
                        if(!is_edit && val!='-1'){
                            return true
                        }
                        // return false 
                    },
                    fun:(val,index)=>{
                        console.log(val,index)
                        let tableData = JSON.parse(JSON.stringify(this.tableData.data))
                        tableData[index].is_edit = !tableData[index].is_edit
                        this.tableData.data = tableData
                    }
                },
                {
                    btn:'取消编辑',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit)=>{
                        if(is_edit && val!='-1'){
                            return true
                        }
                        // return false 
                    },
                    fun:(val,index)=>{
                        console.log(val)
                        let tableData = JSON.parse(JSON.stringify(this.tableData.data))
                        tableData[index].is_edit = !tableData[index].is_edit
                        this.tableData.data = tableData
                    }
                },
                {
                    btn:'审核',
                    btn_type:'text',
                    is_dropdown:true,
                    dropdown_items:[
                        {title:'通过',val:1},
                        {title:'不通过',val:-1}
                    ],
                    //判断这个字段显不显示的函数
                    is_show_fun(val,settle){
                        if(val == 0){
                            return true
                        }
                        return false 
                    },
                    fun: async (e,val)=>{
                        let val_obj = {
                            id:val.id,
                            status:e,
                            check_admin:this.user_info.user_id,
                            check_admin_name:this.user_info.name,
                        }
                        let params = {
                            access_token: localStorage.getItem("access_token"),
                            ...val_obj,
                            operation:true
                        }
        
                        let res = await this.api.wallpaper_check(params);
                        if(res){
                            this.get_wallpaper_list()
                        }else{
                            this.$message({
                                type:'error',
                                message:'审核失败',
                                offset:65,
                            })
                        }
                    }
                },
                {
                    btn:'上架',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit,value)=>{
                        if((val!='0' &&val!='-1') && value.shelf_status == '0'){
                            return true
                        }
                        return false 
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            id:val.id,
                            shelf_status:val.shelf_status=='1'?'0':'1'
                        }
                        this.edit_data = {
                            lable:'这条数据',
                            newValue:val.shelf_status=='1'?'下架':'上架',
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {
                    btn:'下架',
                    btn_type:'text',
                    is_show_fun:(val,is_edit,value)=>{
                        if((val!='0' &&val!='-1') && value.shelf_status == '1'){
                            return true
                        }
                        return false 
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            id:val.id,
                            shelf_status:val.shelf_status=='1'?'0':'1'
                        }
                        this.edit_data = {
                            lable:'这条数据',
                            newValue:val.shelf_status=='1'?'下架':'上架',
                        }
                        this.edit_dialogVisible = true
                    }
                },
                // {
                //     btn:'状态',
                //     btn_type:'text',
                //     is_dropdown:true,
                //     dropdown_items:[
                //         {title:'免费',val:0},
                //         {title:'会员',val:1},
                //         {title:'限免',val:2}
                //     ],
                //     //判断这个字段显不显示的函数
                //     is_show_fun(val,settle){
                //         if(val == 1){
                //             return true
                //         }
                //         return false
                //     },
                //     fun: async (e,val)=>{
                //         let val_obj = {
                //             id:val.id,
                //             lock_status:e,
                //             lock_time:val.lock_time,
                //             is_top:val.is_top,
                //         }
                //         let params = {
                //             access_token: localStorage.getItem("access_token"),
                //             ...val_obj,
                //             operation:true
                //         }
        
                //         let res = await this.api.wallpaper_edit(params);
                //         if(res){
                //             if(this.checkStatus == '4'){
                //                 if(this.activeName=='1'){
                //                     var paramss = {
                //                         page:this.page,
                //                         limit:this.limit,
                //                         status:'1',
                //                         is_top:this.activeName,
                //                         ...this.screen_params,
                //                     }
                //                 }else{
                //                     var paramss = {
                //                         page:this.page,
                //                         limit:this.limit,
                //                         status:1,
                //                         category:this.activeName,
                //                         ...this.screen_params,
                //                     }
                //                 }
                //             }else{
                //                 var paramss = {
                //                     status:this.checkStatus == 'all'?'':(this.checkStatus=='4'?'1':this.checkStatus),
                //                     page:this.page,
                //                     limit:this.limit,
                //                     ...this.screen_params
                //                 }
                //             }
                //             this.get_wallpaper_list(paramss)
                //         }else{
                //             this.$message.error('操作失败');
                //         }
                //     }
                // }
            ],
            ID_btnList:[
                {
                    btn:'详情',
                    btn_type:'text',
                    fun:(val)=>{
                        console.log(val)
                    }
                },
                {
                    btn:'编辑',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit)=>{
                        // console.log(val,is_edit,'is_edit')
                        if(!is_edit && val!='-1'){
                            return true
                        }
                        // return false 
                    },
                    fun:(val,index)=>{
                        console.log(val,index)
                        let tableData = JSON.parse(JSON.stringify(this.tableData.data))
                        tableData[index].is_edit = !tableData[index].is_edit
                        this.tableData.data = tableData
                    }
                },
                {
                    btn:'取消编辑',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit)=>{
                        if(is_edit && val!='-1'){
                            return true
                        }
                        // return false 
                    },
                    fun:(val,index)=>{
                        // console.log(val)
                        let tableData = JSON.parse(JSON.stringify(this.tableData.data))
                        tableData[index].is_edit = !tableData[index].is_edit
                        this.tableData.data = tableData
                    }
                },
                // {
                //     btn:'删除',
                //     btn_type:'text',
                //     fun:(val)=>{
                //         console.log(val)
                //         this.del_id = val.id
                //         this.del_dialogVisible = true
                //     }
                // },
                {
                    btn:'上架',
                    btn_type:'text',
                    //判断这个字段显不显示的函数
                    is_show_fun:(val,is_edit,value)=>{
                        if(val!='-1' && value.shelf_status == '0'){
                            return true
                        }
                        return false 
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            id:val.id,
                            shelf_status:val.shelf_status=='1'?'0':'1'
                        }
                        this.edit_data = {
                            lable:'这条数据',
                            newValue:val.shelf_status=='1'?'下架':'上架',
                        }
                        this.edit_dialogVisible = true
                    }
                },
                {
                    btn:'下架',
                    btn_type:'text',
                    is_show_fun:(val,is_edit,value)=>{
                        if(val!='-1' && value.shelf_status == '1'){
                            return true
                        }
                        return false 
                    },
                    fun:(val)=>{
                        console.log(val)
                        this.fun_callback_data={
                            id:val.id,
                            shelf_status:val.shelf_status=='1'?'0':'1'
                        }
                        this.edit_data = {
                            lable:'这条数据',
                            newValue:val.shelf_status=='1'?'下架':'上架',
                        }
                        this.edit_dialogVisible = true
                    }
                },
                // {
                //     btn:'状态',
                //     btn_type:'text',
                //     is_dropdown:true,
                //     dropdown_items:[
                //         {title:'免费',val:0},
                //         {title:'会员',val:1},
                //         {title:'限免',val:2}
                //     ],
                //     //判断这个字段显不显示的函数
                //     is_show_fun(val,settle){
                //         if(val == 1){
                //             return true
                //         }
                //         return false
                //     },
                //     fun: async (e,val)=>{
                //         let val_obj = {
                //             id:val.id,
                //             lock_status:e,
                //             lock_time:val.lock_time,
                //             is_top:val.is_top,
                //         }
                //         let params = {
                //             access_token: localStorage.getItem("access_token"),
                //             ...val_obj,
                //             operation:true
                //         }
        
                //         let res = await this.api.wallpaper_edit(params);
                //         if(res){
                //             if(this.activeName=='1'){
                //                 var paramss = {
                //                     page:this.page,
                //                     limit:this.limit,
                //                     status:'1',
                //                     is_top:this.activeName,
                //                     ...this.screen_params
                //                 }
                //             }else{
                //                 var paramss = {
                //                     page:this.page,
                //                     limit:this.limit,
                //                     status:1,
                //                     category:this.activeName,
                //                     ...this.screen_params
                //                 }
                //             }
                //             this.get_wallpaper_list(paramss)
                //         }else{
                //             this.$message.error('审核失败');
                //         }
                //     }
                // }
            ],
            is_batch:{
                pending_batch:false,
                through_batch:false,
                intervene_batch:false,
            },
            isAllCheck:false,
            page:1,
            limit:12,
            all_status:'0',
            data_obj:{
                total:0
            },
            drawer:false,//筛选
            direction:'rtl',//筛选框打开的方向
            rawer_list:[
                {label:'上线ID',prop:'id',open_id:'',placeholder:"请输入上线ID检索",},
                // {label:'作品ID',prop:'work_id',username:'',placeholder:"请输入作品ID检索"},
                {label:'素材名称',prop:'name',open_id:'',placeholder:"请输入素材名称检索",},
                // {label:'素材来源',prop:'source',username:'',placeholder:"请输入素材来源检索"},
                // {label:'壁纸标签',prop:'tags',username:'',placeholder:"请输入壁纸标签检索"},
                {label:'素材分类',prop:'category',category_list:[],category:'',placeholder:"请选择素材分类检索"},
                {label:'会员状态',prop:'lock_status',
                    lock_status_list:[
                        {
                            value: '0',
                            label: '免费'
                        }, {
                            value: '1',
                            label: '会员'
                        },
                        {
                            value: '2',
                            label: '限免'
                        }
                    ],lock_status:'',placeholder:"请选择会员状态"
                },
                {
                    label:'是否首页显示',prop:'is_top',is_top_list:[
                        {
                            value: '1',
                            label: '是'
                        }, {
                            value: '0',
                            label: '否'
                        },
                    ],is_top:'',placeholder:"请选择是否首页显示"
                },
                {
                    label:'上下架状态',prop:'shelf_status',shelf_status_list:[
                        {
                            value: '1',
                            label: '上架'
                        }, {
                            value: '0',
                            label: '下架'
                        },
                    ],shelf_status:'',placeholder:"请选择上下架状态"
                }
                // {label:'审核人',prop:'check_admin_name',username:'',placeholder:"请输入审核人检索"},
            ],
            rawer_list2:[
                {label:'上线ID',prop:'id',open_id:'',placeholder:"请输入上线ID检索",},
                // {label:'作品ID',prop:'work_id',username:'',placeholder:"请输入作品ID检索"},
                {label:'素材名称',prop:'name',open_id:'',placeholder:"请输入素材名称检索",},
                // {label:'素材来源',prop:'source',username:'',placeholder:"请输入素材来源检索"},
                // {label:'壁纸标签',prop:'tags',username:'',placeholder:"请输入壁纸标签检索"},
                {label:'素材分类',prop:'category',category_list:[],category:'',placeholder:"请选择素材分类检索"},
                {label:'会员状态',prop:'lock_status',
                    lock_status_list:[
                        {
                            value: '0',
                            label: '免费'
                        }, {
                            value: '1',
                            label: '会员'
                        },
                        {
                            value: '2',
                            label: '限免'
                        }
                    ],lock_status:'',placeholder:"请选择会员状态"
                },
                {
                    label:'当前状态',prop:'status',status_list:[
                        {
                            value: '0',
                            label: '待审核'
                        }, {
                            value: '1',
                            label: '审核通过'
                        },
                        {
                            value: '2',
                            label: '审核驳回'
                        },
                        {
                            value: '',
                            label: '全部'
                        }
                    ],status:'',placeholder:"请选择当前状态"
                },
                {
                    label:'是否首页显示',prop:'is_top',is_top_list:[
                        {
                            value: '1',
                            label: '是'
                        }, {
                            value: '0',
                            label: '否'
                        },
                    ],is_top:'',placeholder:"请选择是否首页显示"
                },
                {
                    label:'上下架状态',prop:'shelf_status',shelf_status_list:[
                        {
                            value: '1',
                            label: '上架'
                        }, {
                            value: '0',
                            label: '下架'
                        },
                    ],shelf_status:'',placeholder:"请选择上下架状态"
                }
                // {label:'审核人',prop:'check_admin_name',username:'',placeholder:"请输入审核人检索"},
            ],
            check_arr:[],
            dialogVisible:false,
            success_arr :[],
            err_arr : [],
            err_num:0,
            loading:false,
            set_stauts:'0',
            pro:null,
            category_arr:[],
            activeName:'1',
            del_dialogVisible:false,
            del_id:'',
            screen_params:{},
            edit_name:'编辑',
            category_data:[],
            edit_dialogVisible:false,
            user_info:{}
        }
    },
    mounted(){ 
        this.get_wallpaper_list()
        this.get_wallpaper_categorylist()
        this.get_selfInfo()
    },
    methods:{
        batch_handleClose(){
            this.batch_time_dialogVisible = false
        },
        change_batch_picker(){
            this.batch_lock_time_val = this.dateFormat("YYYY-mm-dd HH:MM", this.batch_lock_time_val)
            console.log(this.change_batch_picker,'change_batch_picker')
        },
        get_selfInfo(){
            this.api.selfInfo({
                access_token:localStorage.getItem("access_token")
            }).then(da=>{
                console.log(da,'sss')
                this.user_info = da
            })
        },
        change_picker(){
            this.lock_time_val = this.dateFormat("YYYY-mm-dd HH:MM", this.lock_time_val)
            console.log(this.lock_time_val,'this.lock_time_val')
            this.fun_callback_data.lock_time = this.lock_time_val
        },
        async edit_confirm(){
            if(!this.edit_data.newValue){
                return this.$message({
                    type:'error',
                    message:this.edit_data.lable+'不能为空',
                    offset:65,
                })
            }
            if(this.edit_data.is_lock){
                if(!this.lock_time_val){
                    return this.$message({
                        type:'error',
                        message:'请选择限免到期时间',
                        offset:65,
                    })
                }
            }
            let params = {
                access_token: localStorage.getItem("access_token"),
                ...this.fun_callback_data,
                operation:true
            }

            let res = await this.api.wallpaper_edit(params);
            if(res){
                if(this.checkStatus == '4'){
                    if(this.activeName=='1'){
                        var paramss = {
                            page:this.page,
                            limit:this.limit,
                            status:'1',
                            is_top:this.activeName,
                            ...this.screen_params,
                        }
                    }else{
                        var paramss = {
                            page:this.page,
                            limit:this.limit,
                            status:1,
                            category:this.activeName,
                            ...this.screen_params,
                        }
                    }

                }else{
                    var paramss = {
                        ...this.screen_params
                    }
                }
                this.edit_dialogVisible = false
                this.lock_time_val = ''
                this.get_wallpaper_list(paramss)
            }else{
                this.$message({
                    type:'error',
                    message:'操作失败',
                    offset:65,
                })
            }
        },
        edit_handleClose(){
            this.edit_dialogVisible = false
            if(this.checkStatus == '4'){
                if(this.activeName=='1'){
                    var paramss = {
                        page:this.page,
                        limit:this.limit,
                        status:'1',
                        is_top:this.activeName,
                        ...this.screen_params,
                    }
                }else{
                    var paramss = {
                        page:this.page,
                        limit:this.limit,
                        status:1,
                        category:this.activeName,
                        ...this.screen_params,
                    }
                }

            }else{
                var paramss = {
                    ...this.screen_params
                }
            }
            this.get_wallpaper_list(paramss)
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                };
            };
            return fmt;
        },
        reset(){
            this.screen_params = {}
        },
        del(){
            let val_obj = {
                id:this.del_id,
            }
            let params = {
                access_token: localStorage.getItem("access_token"),
                ...val_obj,
                operation:true
            }

            let res = this.api.wallpaper_del(params);
            if(res){
                if(this.activeName=='1'){
                    var paramss = {
                        page:this.page,
                        limit:this.limit,
                        status:'1',
                        is_top:this.activeName
                    }
                }else{
                    var paramss = {
                        page:this.page,
                        limit:this.limit,
                        status:1,
                        category:this.activeName
                    }
                }
                this.del_dialogVisible = false
                this.get_wallpaper_list(paramss)
            }else{
                this.$message({
                    type:'error',
                    message:'审核失败',
                    offset:65,
                })
            }
        },
        handleClose_del(){
            this.del_dialogVisible = false
        },
        handleClick(e){
            this.check_arr = []
            this.page = 1
            this.limit = 12
            this.screen_params = {}
            this.$refs.rawer.chongZhi()
            if(this.activeName=='1'){
                var params = {
                    page:this.page,
                    limit:this.limit,
                    status:'1',
                    is_top:this.activeName
                }
            }else{
                var params = {
                    page:this.page,
                    limit:this.limit,
                    status:1,
                    category:this.activeName
                }
            }
            this.get_wallpaper_list(params)
        },
        sum(arr,itme)  {
            var isTrue = arr.some((currentValue, indexs) => {
                return currentValue.id === itme.id;
            })

            if(isTrue){
                arr.forEach((val,index)=>{
                    if(val.id == itme.id){
                        val.checked = true
                    }
                })
            }else{
                arr.forEach((val,index)=>{
                    if(val.id == itme.id){
                        val.checked = false
                    }
                })
            }
            return arr
        },
        handleClose(){
            this.dialogVisible = false
        },
        get_check_arr(val){
            this.check_arr = val
        },
        set_tableData(val){
            this.tableData.data = val

        },  
        handleClose_drawer(){
            this.drawer = false
        },
        //筛选事件
        screen(val){
            console.log(val,'筛选事件')
            let params = {
                page:1,
                limit:12,
                status:this.checkStatus=='all'?'':(this.checkStatus=='4'?'1':this.checkStatus),
                ...val
            }

            if(this.checkStatus=='4'){
                if(this.activeName == '1'){
                    params.is_top = '1'
                    if(val.is_top){
                        params.is_top = val.is_top
                    }
                }else{
                    params.category = this.activeName
                }
            }
            this.screen_params = JSON.parse(JSON.stringify(params))
            console.log(params,'params')
            this.get_wallpaper_list(params)
            this.drawer = false
        },
        async get_wallpaper_categorylist(){
            let data = await this.api.wallpaper_categorylist({
                access_token: localStorage.getItem("access_token"),
            });
            if(data){
                console.log(data,'分类')

                this.category_arr = JSON.parse(JSON.stringify(data.data))
                this.category_arr = this.category_arr.map((itme)=>{
                    return{
                        label:itme.category,
                        value:itme.category
                    }
                })
                this.category_arr.unshift({
                    label:'首页展示',
                    value:'1'
                })

                this.rawer_list.forEach((val)=>{
                    if(val.prop == "category"){
                        val.category_list = data.data.map((itme)=>{
                            return{
                                label:itme.category,
                                value:itme.category
                            }
                        })
                    }
                })
                this.rawer_list2.forEach((val)=>{
                    if(val.prop == "category"){
                        val.category_list = data.data.map((itme)=>{
                            return{
                                label:itme.category,
                                value:itme.category
                            }
                        })
                    }
                })

                this.category_data = JSON.parse(JSON.stringify(data.data))
                this.category_data = this.category_data.map((itme)=>{
                    return{
                        label:itme.category,
                        value:itme.category
                    }
                })

                this.tableTitle.forEach((val)=>{
                    if(val.prop === "category"){
                        val.props = this.category_data
                    }
                })

                console.log(this.tableTitle,'this.tableTitle')

                console.log(this.category_arr,'category_arr')
            }
        },
        set_page(val){
            console.log(this.screen_params,'this.screen_params33')
        // this.screen_params = {}
            // this.$refs.rawer.chongZhi()
            console.log(this.screen_params,'this.screen_params44')
            if(this.checkStatus == '4'){
                if(this.activeName=='1'){
                    var params = {
                        status:'1',
                        is_top:this.activeName,
                        ...this.screen_params
                    }
                }else{
                    var params = {
                        status:1,
                        category:this.activeName,
                        ...this.screen_params
                    }
                }
                params.page = val
            }
            this.page = val
            this.get_wallpaper_list(this.checkStatus == '4'?params:'')
        },
        set_limit(val){
            if(this.checkStatus == '4'){
                if(this.activeName=='1'){
                    var params = {
                        status:'1',
                        is_top:this.activeName
                    }
                }else{
                    var params = {
                        status:1,
                        category:this.activeName
                    }
                }
                params.page = 1
                params.limit = val
            }
            this.page = 1
            this.limit = val
            this.get_wallpaper_list(this.checkStatus == '4'?params:'')
        },
        // 判断B数组中的所有元素是否都在A数组中
        check(A,B){
            var flag;
            for(var i=0; i<B.length; i++){
                flag = false;
                for(var j=0; j<A.length; j++)
                {
                    if(B[i].id == A[j].id)
                    {
                        flag = true;
                        break;
                    }
                }
                //如果这个循环没有找到
                if(!flag)
                    break;
            }
            return flag;
        },
        async get_wallpaper_list(da) {
            this.all_status = this.checkStatus == 'all'?'':(this.checkStatus=='4'?'1':this.checkStatus)

            let params = {
                ...this.screen_params,
                access_token: localStorage.getItem("access_token"),
                status:this.all_status,
                page:this.page,
                limit:this.limit,
                ...da,
            }
            let data = await this.api.wallpaper_list(params);
            if(data){
                    this.tableData = JSON.parse(JSON.stringify(data))
                    let tableData = JSON.parse(JSON.stringify(this.tableData))

                    tableData.data.forEach(val=>{
                        val.tags = JSON.parse(val.tags).join(",")
                    })

                    this.page = data.page
                    this.limit = data.limit

                    tableData.data.forEach((val)=>{
                        val.checked = false,
                        val.is_edit = false
                    })

                    this.check_arr.forEach((val)=>{
                        this.sum(tableData.data,val)
                    })

                    if(this.is_batch.pending_batch || this.is_batch.through_batch || this.is_batch.intervene_batch){
                        let is_check = this.check(this.check_arr,tableData.data)
                        if(is_check){
                            console.log('是')
                            this.isAllCheck = true
                        }else{
                            console.log('否')
                            this.isAllCheck = false
                        }
                    }

                    this.tableData = tableData


                    // console.log(this.tableData.data,'data')
                    // console.log(this.check_arr,'check_arr')
            }
        },
        add_intervene(){
            this.$router.push({ path:'/review/add_intervene'  })
        },  
        open_check_examine(){
            console.log('点击限免按钮')
            this.batch_time_dialogVisible = true
        },
        check_examine_2(){

            if(!this.batch_lock_time_val){
                return this.$message({
                    type:'error',
                    message:'请选择限免到期时间',
                    offset:65,
                })
            }

            this.loading = true
            let _this = this
            this.pro = this.check_arr.map((val)=>{
                return  new Promise((resolve, reject) => {
                    let val_obj = {
                        id:val.id,
                        lock_status:_this.set_stauts,
                        lock_time:this.batch_lock_time_val,
                    }
                    let params = {
                        access_token: localStorage.getItem("access_token"),
                        ...val_obj,
                    }
    
                    let res = this.api.wallpaper_edit(params);
                    res.then((suc) => {
                        resolve(val)
                    }).catch(err=>{
                        reject(val)
                    })

                })
            })
            Promise.all(this.pro).then((val) => {
                this.$message({
                    type:'success',
                    message:'操作成功',
                    offset:65,
                })
                console.log(val,'全部')
                this.loading = false
                this.batch_time_dialogVisible = false
                this.dialogVisible = false
                // this.is_batch.pending_batch = false
                // this.is_batch.through_batch = false
                this.check_arr = []
                this.get_wallpaper_list()
            }).catch(err=>{
                console.log(err,'全部2')
                this.loading = false
                this.batch_time_dialogVisible = false
                this.dialogVisible = false
                // this.is_batch.pending_batch = false
                // this.is_batch.through_batch = false
                this.check_arr = []
                this.get_wallpaper_list()
            })
        },
        check_examine(){
            this.loading = true
            let _this = this
            console.log(_this.set_stauts,'_this.set_stauts,')

            if(this.checkStatus == '0'){
                this.pro = this.check_arr.map((val)=>{
                    return  new Promise((resolve, reject) => {
                        let val_obj = {
                            id:val.id,
                            status:_this.set_stauts,
                            check_admin:this.user_info.user_id,
                            check_admin_name:this.user_info.name,
                        }
                        let params = {
                            access_token: localStorage.getItem("access_token"),
                            ...val_obj
                        }

                        let res = this.api.wallpaper_check(params);
                        res.then((suc) => {
                            resolve(val)
                        }).catch(err=>{
                            reject(val)
                        })

                    })
                })
            }else if (this.checkStatus == '1'){
                this.pro = this.check_arr.map((val)=>{
                    return  new Promise((resolve, reject) => {
                        let val_obj = {
                            id:val.id,
                            lock_status:_this.set_stauts,
                            lock_time:val.lock_time,
                            is_top:val.is_top,
                        }
                        let params = {
                            access_token: localStorage.getItem("access_token"),
                            ...val_obj,
                        }
        
                        let res = this.api.wallpaper_edit(params);
                        res.then((suc) => {
                            resolve(val)
                        }).catch(err=>{
                            reject(val)
                        })

                    })
                })
            }else if (this.checkStatus == '4'){
                this.pro = this.check_arr.map((val)=>{
                    return  new Promise((resolve, reject) => {
                        let val_obj = {
                            id:val.id,
                            is_top:_this.set_stauts,
                        }
                        if(this.activeName=='1'){
                            val_obj.top_sort = val.top_sort
                        }else{
                            val_obj.category = this.activeName
                            val_obj.sort = val.sort
                        }
                        let params = {
                            access_token: localStorage.getItem("access_token"),
                            ...val_obj,
                        }

                        console.log(params,'params')
        
                        let res = this.api.wallpaper_edit(params);
                        res.then((suc) => {
                            resolve(val)
                        }).catch(err=>{
                            reject(val)
                        })

                    })
                })
            }
            Promise.all(this.pro).then((val) => {
                this.$message({
                    type:'success',
                    message:'操作成功',
                    offset:65,
                })
                console.log(val,'全部')
                this.loading = false
                this.dialogVisible = false
                // this.is_batch.pending_batch = false
                // this.is_batch.through_batch = false
                this.check_arr = []
                if(this.activeName=='1'){
                    var params = {
                        is_top:1,
                    }
                }else{
                    var params = {
                        category:this.activeName
                    }
                }

                this.get_wallpaper_list(params)
            }).catch(err=>{
                console.log(err,'全部2')
                this.loading = false
                this.dialogVisible = false
                // this.is_batch.pending_batch = false
                // this.is_batch.through_batch = false
                this.check_arr = []
                this.get_wallpaper_list()
            })
        },
        edit_batchExamineClick(type,status){
            this.set_stauts = status
            if(type=='lock_status'){ //会员状态
                //批量修改
                if(status=='0'){
                    if(!this.check_arr.length){
                        return this.$message({
                            type:'error',
                            message:'请选择需要修改成免费的素材',
                            offset:65,
                        })
                    }
                    this.dialogVisible = true
                }else if(status=='1'){
                    if(!this.check_arr.length){
                        return this.$message({
                            type:'error',
                            message:'请选择需要修改成会员的素材',
                            offset:65,
                        })
                    }
                    this.dialogVisible = true
                }else{
                    if(!this.check_arr.length){
                        return this.$message({
                            type:'error',
                            message:'请选择需要修改成限免的素材',
                            offset:65,
                        })
                    }
                    this.dialogVisible = true
                }
            }else if(type == 'is_top'){
                if(status=='1'){
                    if(!this.check_arr.length){
                        return this.$message({
                            type:'error',
                            message:'请选择需要首页显示的素材',
                            offset:65,
                        })
                    }
                    this.dialogVisible = true
                }else{
                    if(!this.check_arr.length){
                        return this.$message({
                            type:'error',
                            message:'请选择不需要首页显示的素材',
                            offset:65,
                        })
                    }
                    this.dialogVisible = true
                }
            }
        },
        batchExamineClick(status){
            this.set_stauts = status
            //批量审核通过
            if(status=='1'){
                if(!this.check_arr.length){
                    return this.$message({
                        type:'error',
                        message:'请选择审核通过的素材',
                        offset:65,
                    })
                }
                this.dialogVisible = true
            }else{
                if(!this.check_arr.length){
                    return this.$message({
                        type:'error',
                        message:'请选择审核不通过的壁纸',
                        offset:65,
                    })
                }
                this.dialogVisible = true
            }
        },
        //对象数组中根据id/其他属性值判断是否有某条数据，有就删除，没有就添加
        change_sum(arr,itme)  {
            var isTrue = arr.some((currentValue, indexs) => {
                return currentValue.id === itme.id;
            })

            if(isTrue){
                arr.forEach((val,index)=>{
                if(val.id == itme.id){
                    arr.splice(index,1)
                }
            })
            }else{
                arr.push(itme)
            }
            return arr
        },
        del_check(A,B){
            for(var i=0; i<B.length; i++){
                for(var j=0; j<A.length; j++){
                    if(B[i] == A[j]){
                        A.splice(j,1)
                        break;
                    }
                }
            }
        },
        uniqueFunc(arr, uniId){
            const res = new Map();
            return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
        },
        allCheckChange(e){
            console.log(e,'ee')
            let arr = JSON.parse(JSON.stringify(this.tableData.data))
            arr.forEach((val)=>{
                val.checked = e
                if(e){
                    this.check_arr.push(val)
                    this.check_arr = this.uniqueFunc(this.check_arr,'id')
                }else{
                    this.change_sum(this.check_arr,val)
                }
            })

            this.tableData.data = arr
        },
        close_batch_fun(){
            if(this.checkStatus=='0'){
                this.is_batch.pending_batch = false
            }else if(this.checkStatus=='1'){
                this.is_batch.through_batch = false
            }else if(this.checkStatus=='4'){
                this.is_batch.intervene_batch = false
            }
            this.isAllCheck = false
            this.check_arr = []
            let arr = JSON.parse(JSON.stringify(this.tableData.data))
            arr.forEach((val)=>{
                val.checked = false
            })
            this.tableData.data = arr
        },
        batch_fun(){
            if(this.checkStatus=='0'){
                this.is_batch.pending_batch = true
                this.is_batch.through_batch = false
                this.is_batch.intervene_batch = false
            }else if(this.checkStatus=='1'){
                this.is_batch.through_batch = true
                this.is_batch.pending_batch = false
                this.is_batch.intervene_batch = false
            }else if(this.checkStatus == '4'){
                this.is_batch.intervene_batch = true
                this.is_batch.through_batch = false
                this.is_batch.pending_batch = false
            }
        },
        tabHandleClick(){
            this.is_batch.pending_batch = false
            this.is_batch.through_batch = false
            this.is_batch.intervene_batch = false
            this.isAllCheck = false
            this.screen_params = {}
            this.$refs.rawer.chongZhi()

            this.check_arr = []
            let arr = JSON.parse(JSON.stringify(this.tableData.data))
            arr.forEach((val)=>{
                val.checked = false
            })
            this.tableData.data = arr


            this.page = 1
            this.limit = 12
            if(this.checkStatus != '4'){
                this.get_wallpaper_list()
            }else{
                let val_obj = {
                    is_top:'1',
                    status:'1',
                    page : 1,
                    limit : 12
                }
                let params = {
                    access_token: localStorage.getItem("access_token"),
                    ...val_obj
                }
                this.get_wallpaper_list(params)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
@import "styles/define";
.p-works-contribution-page{
    height: 100%;
    overflow: hidden;
    .p-operation{
        background-color: $background-color-base;
        padding-bottom: 10px;
        .p-right-operation-btn{
            width: 100%;
            display: flex;
            justify-content: space-between;
            text-align: right;
            .p-fitler-btn{
                display: flex;
                justify-items: center;
                display: inline-block;
                img{
                    margin-right: 4px;
                }
            }
        }
        .el-tabs__header {
            margin: 0;
        }
        .el-tabs__nav-wrap::after {
            display: none;
        }
        .el-col {
            min-height: 1px;
        }
        .p-tabs {
            position: fixed;
            left: 50%;
            top: 8px;
            transform: translateX(-50%);
        }
    }
    .p-table-wrap{
        overflow-x: hidden;
        overflow-y: scroll;
    }
    .p-table-wrap, .p-card-wrap{
        display: flex;
        flex-direction: column;
        height: calc(100% - 230px);
        background-color: white;
        .p-table{
            flex: 1;
            .p-img-preview{
                max-width: 80px;
                max-height: 80px;
            }
            .p-prize-name{
                color: #999;
                // 上架中样式
                &.p-prize-name-up{
                    font-weight: bold;
                    cursor: pointer;
                    color: #33B3FF;
                }
            }
            .p-status{
                color: #999;
            }
            .el-dropdown-link {
                cursor: pointer;
                color: #33B3FF;
                font-weight: bold;
            }
        }
        .p-table-paging-wrap, .p-card-pagination-wrap {
            text-align: right;
        }
        .p-card-pagination-wrap {
            padding-right: 30px;
        }
        .p-operation-wrap{
            height: 50px;
            padding: 10px 30px 10px;
            box-shadow: 0 1px 5px 5px #eee;
            display: flex;
            justify-content: start;
            align-items: center;
            position: absolute;
            bottom: 30px;
            left: 82px;
            right: 20px;
            background: #fff;
            .p-count {
                >span {
                    margin-right: 10px;
                }
            }
            .p-btns {
                position: absolute;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);
            }
        }
        .p-detail-btn {
            margin-right: 10px;
        }
    }
    .dialog_container{
        overflow-x: hidden;
        overflow-y: scroll;
        height: 500px;
        .el-row{
            .el-col{
                display: flex;
                justify-content: center;
                margin: 10px 0;
                .left_box{
                    display: flex;
                    justify-content: center;
                    width: 200px;
                    background: #eee;
                    img{
                        width: 100px;
                    }
                }
                .right_box{
                    margin-left: 20px;
                    .dialog_p{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        margin: 10px 0;
                        .tips{
                            display: flex;
                            margin-left: 40px;
                            border:1px solid #ccc;
                            padding: 5px 10px;
                            min-width: 100px;
                            border-radius: 5px;
                        }
                        .dialog_name{
                            margin-right: 30px;
                        }
                    }
                    .gan_input{
                        &.el-input{
                            width: 122px;
                        }
                    }
                }
            }
        }
    }
    .edit_dialogVisible_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        .tips_text_box{
            color: red;;
        }
        .picker_box{
            margin-top: 20px;
        }
    }
    .shtion{
		position: fixed;
		width: 100%;
		height: 100%;
		top: 0;
		left:0;

		pointer-events: none;
	}
}
.batch_dialogVisible_box{
    display: flex;
    justify-content: center;
    align-items: center;
    
}
</style>

<style lang="scss">
.p-works-contribution-page{
.el-tabs__nav-wrap::after {
    display: none;
    background: ye;
}
}
</style>
